<div class="network-content">
  <div class="network-tabs-container">
    <!-- ! Chips -->
    <ddc-tabs-chips
      [tabs]="[
        { key: 'overview', label: 'Overview', icon: _iconNames.OVERVIEW, selected: _isOverviewSelected },
        { key: 'followers', label: 'Followers', icon: _iconNames.FOLLOWERS, selected: _isFollowersSelected },
        { key: 'following', label: 'Following', icon: _iconNames.FOLLOWING, selected: _isFollowingSelected },
      ]"
      [theme]="_isLightTheme ? 'light' : _isDarkTheme ? 'dark' : 'paper'"
      (tabClick)="clickedChip($event)"
    ></ddc-tabs-chips>
  </div>
  <div class="network-content-container">
    <!-- ! Overview -->
    <div class="network-overview-container" *ngIf="_isOverviewSelected">
      <div class="network-overview-holder" *ngIf="!_isOverviewLoading">
        <!-- o-followers -->
        <div
          class="overview-followers-cont"
          [ngClass]="{
            'ddc-home-card-light-1': _isLightTheme,
            'ddc-home-card-dark-1': _isDarkTheme,
            'ddc-home-card-paper-1': _isPaperTheme,
          }"
          (click)="dashboardElementClicked('followers')"
        >
          <div class="overview-w-label">
            <span class="material-icons ddc-chip-icon"> groups </span>
            <div>Followers</div>
          </div>
          <div class="overview-w-number">{{ _ovNFollowers }}</div>
          <!-- <div class="overview-w-lastest">Latest:</div> -->
          <!-- <ddc-small-word
                        [word]="_ovLastUpdatedWord"
                        [with_icon]="false"
                    ></ddc-small-word> -->
        </div>
        <!-- o-following -->
        <div
          class="overview-following-cont"
          [ngClass]="{
            'ddc-home-card-light-2': _isLightTheme,
            'ddc-home-card-dark-2': _isDarkTheme,
            'ddc-home-card-paper-2': _isPaperTheme,
          }"
          (click)="dashboardElementClicked('following')"
        >
          <div class="overview-p-label">
            <span class="material-icons ddc-chip-icon"> person_add_alt_1 </span>
            <div>Following</div>
          </div>
          <div class="overview-p-number">{{ _ovNFollowing }}</div>
          <!-- <div class="overview-p-lastest">Latest:</div> -->
          <!-- <ddc-small-pair
                        [pair]="_ovLastUpdatedPair"
                        [with_icon]="false"
                    ></ddc-small-pair> -->
        </div>
      </div>
      <div class="word-skeletons" *ngIf="_isOverviewLoading" style="display: flex">
        <ddc-loading-skeleton></ddc-loading-skeleton>
      </div>
    </div>
    <!-- ! Followers -->
    <div class="network-followers-container" *ngIf="_isFollowersSelected">
      <!-- ! Content -->
      <div class="followers-content" *ngIf="!_isFollowersLoading" [class.gray-out]="_isInputActive">
        <div
          infiniteScroll
          [infiniteScrollDistance]="1"
          [infiniteScrollThrottle]="500"
          (scrolled)="onFollowersScroll()"
        >
          <div *ngFor="let follower of _followers" style="margin: 10px">
            <ddc-user-one
              [bio]="follower.info.bio"
              [city]="follower.info.city"
              [country]="follower.info.country"
              [dynamicRoute]="'/users/' + follower.username"
              [followersCount]="follower.info.followers_count"
              [lng1]="follower.info.language_1"
              [lng2]="follower.info.language_2"
              [subscription]="follower.info.subscription"
              [type]="'followers'"
              [username]="follower.username"
              [userProfilePic]="follower.info.profile_pic"
              [verified]="follower.info.verified"
            ></ddc-user-one>
          </div>
        </div>
        <div class="word-info-label" *ngIf="_followers.length > 10">
          <ng-lottie
            *ngIf="!_followersEnd && !_followersScrollLoading"
            width="30px"
            [options]="scroll_options"
          ></ng-lottie>
          <ng-lottie *ngIf="_followersScrollLoading" width="50px" [options]="loading_options"></ng-lottie>
          <mat-icon *ngIf="_followersEnd && !_followersScrollLoading">fact_check</mat-icon>&nbsp;&nbsp;{{
            _followersPageInfoLabel
          }}
        </div>

        <ddc-not-available *ngIf="_followers.length === 0" [_elem]="'Follower'"></ddc-not-available>
      </div>
      <div class="word-skeletons" *ngIf="_isFollowersLoading">
        <ddc-loading-skeleton></ddc-loading-skeleton>
      </div>
      <!-- ! If Empty -->
      <div *ngIf="_isFollowersEmpty">{{ _fetchFollowersError }}</div>
    </div>
    <!-- ! Following -->
    <div class="network-following-container" *ngIf="_isFollowingSelected">
      <!-- ! Content -->
      <div class="words-content" *ngIf="!_isFollowingLoading" [class.gray-out]="_isInputActive">
        <div
          infiniteScroll
          [infiniteScrollDistance]="1"
          [infiniteScrollThrottle]="500"
          (scrolled)="onFollowingScroll()"
        >
          <div *ngFor="let followed of _following" style="margin: 10px">
            <ddc-user-one
              [bio]="followed.info.bio"
              [city]="followed.info.city"
              [country]="followed.info.country"
              [dynamicRoute]="'/users/' + followed.username"
              [followersCount]="followed.info.followers_count"
              [lng1]="followed.info.language_1"
              [lng2]="followed.info.language_2"
              [subscription]="followed.info.subscription"
              [type]="'following'"
              [username]="followed.username"
              [userProfilePic]="followed.info.profile_pic"
              [verified]="followed.info.verified"
            ></ddc-user-one>
          </div>
        </div>
        <div class="word-info-label" *ngIf="_following.length > 10">
          <ng-lottie
            *ngIf="!_followingEnd && !_followingScrollLoading"
            width="30px"
            [options]="scroll_options"
          ></ng-lottie>
          <ng-lottie *ngIf="_followingScrollLoading" width="50px" [options]="loading_options"></ng-lottie>
          <mat-icon *ngIf="_followingEnd && !_followingScrollLoading">fact_check</mat-icon>&nbsp;&nbsp;{{
            _followersPageInfoLabel
          }}
        </div>
        <ddc-not-available *ngIf="_following.length === 0" [_elem]="'Following'"></ddc-not-available>
      </div>
      <!-- ! Skeleton -->
      <div class="word-skeletons" *ngIf="_isFollowingLoading">
        <ddc-loading-skeleton></ddc-loading-skeleton>
      </div>
      <!-- ! If Empty -->
      <div *ngIf="_isFollowingEmpty">{{ _fetchFollowingError }}</div>
    </div>
  </div>
</div>
